;(function($){
    // IE Modal Transitions are not work and the modal is not showing
    // - Remove the fade class causing issues
    if (navigator.appVersion.indexOf('MSIE') >= 0) {
        $('.modal.fade').each(function() {
            $(this).removeClass('fade');
        });
    }
})(jQuery);
